import {
  HttpContextToken,
} from '@angular/common/http';

import { AprimaCacheInstance } from '../services/AprimaCacheService';

export const APRIMA_HTTP_CONTEXT_CACHE_INSTANCE = new HttpContextToken<AprimaCacheInstance | undefined>(() => undefined);
export const APRIMA_HTTP_CONTEXT_DISABLE_UNAUTHORIZED_REDIRECT = new HttpContextToken<boolean>(() => false);
